<ng-template #groupingRef let-m>
  <div class="grouping">
    <lib-match [match]="m"></lib-match>
    <div class="previous-matches">
      <ng-container *ngFor="let match of m.previous; let sibling = index">
        <ng-template
          [ngTemplateOutlet]="groupingRef"
          [ngTemplateOutletContext]="{ $implicit: match }"
        ></ng-template>
        <div [ngClass]="getLineClass(match, sibling, m.previous)"></div>
      </ng-container>
    </div>
  </div>
</ng-template>

<div class="bracket">
  <div class="outer-group">
    <div class="round-names">
      <div class="title" *ngFor="let name of roundNames">{{ name }}</div>
    </div>
    <ng-template
      [ngTemplateOutlet]="groupingRef"
      [ngTemplateOutletContext]="{ $implicit: matches.root }"
    ></ng-template>
  </div>
</div>
